import { useQuery } from '@tanstack/react-query';
import { getProgramScopedContentRowsForGradeTerm } from '../../services/programScopedContentService';
import { loadAnnualProgressScopedTermCache } from '../../utils/annualProgressScopedTermCache';
import { schoolKeys } from '../keys';
import { cacheOnlyQueryOptions } from './cacheOnlyQuery';
import { lsInitialDataOptions } from './lsInitialData';
import type { SchoolGradeTermScope } from './types';

export type UseProgramScopedRowsQueryParams = SchoolGradeTermScope & {
  enabled?: boolean;
  forceRefresh?: boolean;
  cacheOnly?: boolean;
};

export function programScopedRowsQueryOptions(params: UseProgramScopedRowsQueryParams) {
  const {
    workspaceId,
    academicYear,
    termNumber,
    gradeId,
    enabled = true,
    forceRefresh = false,
    cacheOnly = false,
  } = params;
  const ls = loadAnnualProgressScopedTermCache(workspaceId, academicYear, termNumber, gradeId);

  return {
    queryKey: schoolKeys.programScopedRows(workspaceId, academicYear, termNumber, gradeId),
    enabled: enabled && !!workspaceId.trim() && !!gradeId.trim(),
    ...lsInitialDataOptions(ls.found, ls.rows),
    ...cacheOnlyQueryOptions(cacheOnly),
    queryFn: () =>
      getProgramScopedContentRowsForGradeTerm(workspaceId, academicYear, termNumber, gradeId, {
        forceRefresh: cacheOnly ? false : forceRefresh,
      }),
  };
}

export function useProgramScopedRowsQuery(params: UseProgramScopedRowsQueryParams) {
  return useQuery(programScopedRowsQueryOptions(params));
}
